import React from 'react';
import { Alert, AlertIcon } from '@chakra-ui/react';

export const InfoBadge = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => (
  <Alert status='warning'>
    <AlertIcon />
    {children}
  </Alert>
);
